module.exports = __webpack_public_path__ + "img/logoDEV.e1ccefa7.svg";